import { supportedLanguages } from './resources.js';

/**
 * 신규 사용자 브라우저 언어 감지 유틸
 * - navigator.languages 또는 navigator.language를 순회
 * - 지역 코드를 제거('ko-KR' -> 'ko')하여 i18n 지원 언어와 일치하는 첫 번째 언어 반환
 * - 일치하는 언어가 없거나 예외 발생 시 'en' 반환
 */
export function detectLanguage(customSupported = supportedLanguages) {
  try {
    if (typeof navigator === 'undefined') return 'en';

    const candidateList =
      Array.isArray(navigator.languages) && navigator.languages.length > 0
        ? navigator.languages
        : navigator.language
        ? [navigator.language]
        : [];

    for (const lang of candidateList) {
      if (!lang || typeof lang !== 'string') continue;
      const code = lang.trim().split('-')[0].toLowerCase();
      if (customSupported.includes(code)) {
        return code;
      }
    }

    return 'en';
  } catch (_) {
    return 'en';
  }
}
